import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ApiModule } from '../api.module';
import {
  ApiTravelHelperPipe,
  ApiTravelHelperUnPurePipe,
} from './travel-helper.pipe';
import {
  ApiTravelMemberHelperPipe,
  ApiTravelMemberHelperUnPurePipe,
} from './travel-member-helper.pipe';
import { ApiTravelMemberAuthService } from './travel-member-auth.service';
import { ApiTravelMemberAuthStorageService } from './travel-member-auth-storage.service';

@NgModule({
  declarations: [
    ApiTravelHelperPipe,
    ApiTravelHelperUnPurePipe,
    ApiTravelMemberHelperPipe,
    ApiTravelMemberHelperUnPurePipe,
  ],
  imports: [CommonModule, ApiModule],
  exports: [
    ApiTravelHelperPipe,
    ApiTravelHelperUnPurePipe,
    ApiTravelMemberHelperPipe,
    ApiTravelMemberHelperUnPurePipe,
  ],
  providers: [
    ApiTravelHelperPipe,
    ApiTravelHelperUnPurePipe,
    ApiTravelMemberHelperPipe,
    ApiTravelMemberHelperUnPurePipe,
  ],
})
export class ApiTravelModule {
  public static forRoot(): ModuleWithProviders<ApiTravelModule> {
    return {
      ngModule: ApiTravelModule,
      providers: [
        ApiTravelMemberAuthService,
        ApiTravelMemberAuthStorageService,
      ],
    };
  }
}
